import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BriefcaseIcon from './components/icons/BriefcaseIcon';
import CalendarIcon from './components/icons/CalendarIcon';
import FlagIcon from './components/icons/FlagIcon';

interface PillButtonInterface {
  onClick?: () => void;
  label: string;
  icon: "calendar" | "briefcase" | "flag";
  active?: boolean;
}

const PillButton = ({ onClick, label, icon, active }: PillButtonInterface) => {
  const { t } = useTranslation(['associations']);

  const fillColor = active ? "#202020" : "#575757";

  const iconComponents = {
    calendar: CalendarIcon,
    briefcase: BriefcaseIcon,
    flag: FlagIcon
  };

  const IconComponent = iconComponents[icon];

  return (
    <button
      onClick={onClick}
      className={classNames(
        'z-10 flex flex-row items-center rounded-full border-1 gap-3 px-5 py-3',
        active && 'border-[#202020]',
        !active && 'shadow-[inset_0_1px_0_rgba(255,255,255,0.8),_inset_0_-1px_0_rgba(0,0,0,0.1)]'
      )}
    >
      <IconComponent fill={fillColor} />
      <p 
        className="text-[0.9375rem] leading-[18px] tracking-[0.005px] font-normal"
        style={{ color: fillColor }}
      >
        {t(label)}
      </p>
    </button>
  );
};

export default PillButton;
